import { render } from "./Experiment.vue?vue&type=template&id=c0dab548&scoped=true"
import script from "./Experiment.vue?vue&type=script&lang=js"
export * from "./Experiment.vue?vue&type=script&lang=js"

import "./Experiment.vue?vue&type=style&index=0&id=c0dab548&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0dab548"]])

export default __exports__